import * as types from './types';

const INITIAL_STATE = {
  reportLoading: false,
  fieldLoading: false,
  reports: [],
  studentReport: [],
  dateReport: [],
  userLoad: false,
  usersData: [],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.HISTORYBYITEM_REPORT_LOAD:
      return { ...state, reportLoading: action.payload };
    case types.GET_HISTORYBYITEM_REPORT:
      return { ...state, reports: action.payload.data.Data };
    case types.GET_HISTORYBYSTUDENT_REPORT:
      return { ...state, studentReport: action.payload.data.Data };
    case types.GET_HISTORYBYSTUDENT_USER:
      return { ...state, usersData: action.payload.data.Data };
    case types.USER_LOAD:
      return { ...state, userLoad: action.payload };

    case types.GET_HISTORYBYDATE_REPORT:
      return { ...state, dateReport: action.payload.data.Data };
    case types.CLEAR_REPORT_DATA:
      return { ...state, reports: [], studentReport: [] };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/transactionhistory/state/reducer.js